import { API } from 'aws-amplify';

class DocTypesService {

   getDocTypes = async () => {
      var ReturnObj = [];
      await API.get('IAPI', 'DocType/docTypes/')
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }

   getDocTypesOptions() {
      return API.get('IAPI', 'DocType/docTypes/').then(
         data => {
            return data.map(
               item => {
                  return {value: item.docTypeMrz, label: item.description}
               }
            )
         }
      ).catch(error=>{
         //console.log(error);
         return []
      })
   }

   deleteDocType = async (doctype) => {
      var ReturnObj = {};
      await API.post('IAPI', 'DocType/Delete/', {
         'queryStringParameters': {
            'id': doctype.id
         },
         body: {}
      })
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   };

   updateData = async (values) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            id: values.id,
            Description:values.Description,
            DocTypeMrz: values.DocTypeMrz         }
      }
      await API.post('IAPI', 'DocType/Update/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }
   addData = async (values) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            DocTypeMrz: values.DocTypeMrz,
            Description:values.Description         }
      }
      await API.post('IAPI', 'DocType/HandleAddPDocType/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }
}

export default new DocTypesService();